import React from 'react';
import { View, StyleSheet, Text, TouchableOpacity, ScrollView } from 'react-native';
import { Title, Paragraph, Chip } from 'react-native-paper';
import { MaterialCommunityIcons } from '@expo/vector-icons';

const ListRow = ({ item, onPlay, onListenTogether, isPlaying, listeners }) => (
  <View style={[styles.row, isPlaying && styles.rowPlaying]}>
    <View style={styles.rowLeft}>
      <View style={styles.iconBadge}>
        <MaterialCommunityIcons name="music" size={18} color="#ffffff" />
      </View>
      <View style={{ flex: 1 }}>
        <Text style={styles.trackTitle} numberOfLines={1}>{item.name}</Text>
        {item.displayCategory ? (
          <Text style={styles.trackMeta} numberOfLines={1}>{item.displayCategory}</Text>
        ) : null}
        <Text style={styles.listeners}>{listeners} dinleyici</Text>
      </View>
    </View>
    <View style={styles.actions}>
      <TouchableOpacity
        style={[styles.actionButton, isPlaying && styles.actionButtonActive]}
        onPress={() => onPlay(item)}
        activeOpacity={0.8}
      >
        <MaterialCommunityIcons name={isPlaying ? 'pause-circle' : 'play-circle'} size={20} color="#ffffff" />
        <Text style={styles.actionText}>{isPlaying ? 'Çalınıyor' : 'Çal'}</Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={styles.actionGhost}
        onPress={(e) => onListenTogether(item, e)}
        activeOpacity={0.8}
      >
        <MaterialCommunityIcons name="account-music" size={18} color="#8bc6ff" />
        <Text style={styles.actionGhostText}>Birlikte</Text>
      </TouchableOpacity>
    </View>
  </View>
);

export default function TopLists({ turkList = [], yabanciList = [], onPlay, onListenTogether, playingRadio, listenerCounts = {} }) {
  if ((!turkList || turkList.length === 0) && (!yabanciList || yabanciList.length === 0)) {
    return null;
  }

  return (
    <View style={styles.wrapper}>
      <Title style={styles.title}>Top Listeler</Title>
      <Paragraph style={styles.subtitle}>Yerli &amp; Yabancı pop listeleri; tek tıkla çalın, sohbet açın.</Paragraph>

      <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={styles.cards}>
        {turkList && turkList.length > 0 && (
          <View style={styles.card}>
            <View style={styles.cardHeader}>
              <Chip compact style={styles.chip} textStyle={styles.chipText}>Yerli Pop</Chip>
              <Text style={styles.cardTitle}>Türkçe Pop Top</Text>
            </View>
            {turkList.map((item) => (
              <ListRow
                key={item._id}
                item={item}
                onPlay={onPlay}
                onListenTogether={onListenTogether}
                isPlaying={playingRadio === item._id}
                listeners={listenerCounts[item._id] !== undefined ? listenerCounts[item._id] : 0}
              />
            ))}
          </View>
        )}

        {yabanciList && yabanciList.length > 0 && (
          <View style={styles.card}>
            <View style={styles.cardHeader}>
              <Chip compact style={styles.chip} textStyle={styles.chipText}>Yabancı Pop</Chip>
              <Text style={styles.cardTitle}>Foreign Pop Picks</Text>
            </View>
            {yabanciList.map((item) => (
              <ListRow
                key={item._id}
                item={item}
                onPlay={onPlay}
                onListenTogether={onListenTogether}
                isPlaying={playingRadio === item._id}
                listeners={listenerCounts[item._id] !== undefined ? listenerCounts[item._id] : 0}
              />
            ))}
          </View>
        )}
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    marginTop: 28,
    marginBottom: 36,
    paddingHorizontal: 4,
  },
  title: {
    color: '#ffffff',
    marginBottom: 4,
  },
  subtitle: {
    color: '#aeb6c7',
    marginBottom: 12,
    fontSize: 13,
  },
  cards: {
    gap: 12,
  },
  card: {
    backgroundColor: '#101218',
    borderRadius: 16,
    padding: 12,
    width: 360,
    borderWidth: 1,
    borderColor: '#1f2430',
  },
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  cardTitle: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: '700',
  },
  chip: {
    backgroundColor: 'rgba(255,255,255,0.08)',
    borderColor: 'rgba(255,255,255,0.12)',
    borderWidth: 1,
  },
  chipText: {
    color: '#e8f0ff',
    fontSize: 12,
    fontWeight: '700',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 10,
    borderBottomColor: '#1f2430',
    borderBottomWidth: 1,
    gap: 10,
  },
  rowPlaying: {
    backgroundColor: 'rgba(233,69,96,0.08)',
    borderRadius: 10,
    paddingHorizontal: 6,
  },
  rowLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    flex: 1,
  },
  iconBadge: {
    width: 34,
    height: 34,
    borderRadius: 10,
    backgroundColor: '#1f2430',
    alignItems: 'center',
    justifyContent: 'center',
  },
  trackTitle: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '700',
  },
  trackMeta: {
    color: '#c7d2e0',
    fontSize: 12,
  },
  listeners: {
    color: '#8aa0c2',
    fontSize: 11,
    marginTop: 2,
  },
  actions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  actionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 10,
    backgroundColor: '#E94560',
  },
  actionButtonActive: {
    backgroundColor: '#d33850',
  },
  actionText: {
    color: '#ffffff',
    fontSize: 13,
    fontWeight: '700',
  },
  actionGhost: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 10,
    backgroundColor: '#151a22',
    borderWidth: 1,
    borderColor: '#1f2430',
  },
  actionGhostText: {
    color: '#8bc6ff',
    fontSize: 12,
    fontWeight: '700',
  },
});

